<template>
  <header
    class="navbar is-fixed-top is-transparent"
    id="nav"
  >
    <div class="container">
      <div class="navbar-brand">
        <a
          class="navbar-item"
          v-scroll-to="'#top'"
        >
          <img
            src="../../static/img/logo.png"
            alt="Logo"
          >
        </a>
        <span
          class="navbar-burger burger"
          data-target="navbarMenuHeroC"
          v-bind:class="{ 'is-active': menuActive }"
          v-on:click="menuToggle()"
        >
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>
      <div
        id="navbarMenuHeroC"
        class="navbar-menu"
        v-bind:class="{'is-active': menuActive}"
      >
        <div class="navbar-end">
          <a
            class="navbar-item"
            v-scroll-to="'#mission'"
            v-on:click="menuToggle()"
          >MISSION</a>
          <a
            class="navbar-item"
            v-scroll-to="'#about'"
            v-on:click="menuToggle()"
          >PRODUCT</a>
          <a
            class="navbar-item"
            v-scroll-to="'#technology'"
            v-on:click="menuToggle()"
          >TECHNOLOGY</a>
          <a
            class="navbar-item"
            v-scroll-to="'#member'"
            v-on:click="menuToggle()"
          >MEMBER</a>
          <a
            class="navbar-item"
            v-scroll-to="'#media'"
            v-on:click="menuToggle()"
          >MEDIA</a>
          <a
            class="navbar-item"
            v-scroll-to="'#sponsor'"
            v-on:click="menuToggle()"
          >SPONSOR</a>
          <a
            class="navbar-item"
            v-scroll-to="'#contact'"
            v-on:click="menuToggle()"
          >CONTACT</a>
          <!-- <div
            class="navbar-item"
            v-scroll-to="'#kick'"
            v-on:click="menuToggle()"
          >
            <a
              class="button is-link"
              href="http://kck.st/2EQHxAu"
            >
              KICKSTARTER
            </a>
          </div> -->
          <div
            class="navbar-item"
            v-scroll-to="'#press'"
            v-on:click="menuToggle()"
          >
            <a
              class="button is-danger"
              href="#"
            >
              PRESS KIT
            </a>
          </div>
          <div class="navbar-item">
            <div class="field is-grouped">
              <p class="control">
                <a
                  class="button is-rounded"
                  href="https://twitter.com/jellysurf_jp"
                >
                  <span class="icon">
                    <i class="fab fa-twitter"></i>
                  </span>
                </a>
              </p>
              <p class="control">
                <a
                  class="button is-rounded"
                  href="https://www.facebook.com/jellysurf"
                >
                  <span class="icon">
                    <i class="fab fa-facebook"></i>
                  </span>
                </a>
              </p>
              <p class="control">
                <a
                  class="button is-rounded"
                  href="https://www.instagram.com/jellysurf.official/"
                >
                  <span class="icon">
                    <i class="fab fa-instagram"></i>
                  </span>
                </a>
              </p>
              <p class="control">
                <router-link
                  class="button"
                  to="/ja"
                >JP</router-link>
              </p>
              <p class="control">
                <a
                  class="button"
                  href="/"
                >EN</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  data () {
    return {
      menuActive: false
    }
  },
  methods: {
    menuToggle () {
      this.menuActive = !this.menuActive
    }
  }
}
</script>

<style lang="scss" scoped>
#nav {
  font-family: "Ubuntu", sans-serif;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue